module.exports = __webpack_public_path__ + "img/step-1.a13c03b7.svg";